/*
 *
 * ServiceRequestsManagerFormDialog14326Container
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { SERVICE_REQUESTS_MANAGER_REQUESTS_FORM_DIALOG, SERVICE_REQUESTS_MANAGER_REQUESTS_TABLE_GRID } from 'pages/Requests/ServiceRequestsManagerView/constants';
import { makeSelectMode } from 'containers/AdvancedFormDialog/selectors/';
import { executeAcceptAction, executeRejectAction, executeCloseAction, executeSendToAgreementByTenantAction, executeSendToPerformer } from './actions';
import { ServiceRequestsManagerFormDialog14326 } from './ServiceRequestsManagerFormDialog14326';
import { makeSelectRoles } from 'domain/User/selectors';
import { makeSelectCurrentRecord, makeSelectSelection, } from 'containers/AdvancedDataTable/selectors';
import ReceptionSendToAgreementByTenantFormDialog from '../ReceptionView/ReceptionSendToAgreementByTenantFormDialog';
import ReceptionSendToAgreementByTenantForm from '../ReceptionView/ReceptionSendToAgreementByTenantForm';


class ServiceRequestsManagerFormDialogContainer14326 extends React.Component {

  componentDidMount() {
    const { params } = this.props
    if (params && params.requestId) {
      this.props.loadDialogData(params.requestId)
    }
  }

  render() {
    return (
      <div>
        <ServiceRequestsManagerFormDialog14326
          onAccept={this.props.executeAcceptAction}
          onReject={this.props.executeRejectAction}
          onClose={this.props.executeCloseAction}
          onSendToAgreementByTenant={this.props.executeSendToAgreementByTenantAction}
          onSendToPerformer={this.props.executeSendToPerformer}
          {...this.props}
        />
        <ReceptionSendToAgreementByTenantFormDialog
          form={<ReceptionSendToAgreementByTenantForm />}
        />
      </div>
    );
  }
}

ServiceRequestsManagerFormDialogContainer14326.propTypes = {
  executeAcceptAction: PropTypes.func.isRequired,
  executeRejectAction: PropTypes.func.isRequired,
  executeCloseAction: PropTypes.func.isRequired,
  executeSendToPerformer: PropTypes.func.isRequired,
  executeSendToAgreementByTenantAction: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({
  mode: makeSelectMode(SERVICE_REQUESTS_MANAGER_REQUESTS_FORM_DIALOG),
  currentRole: makeSelectRoles(),
  currentRecord: makeSelectCurrentRecord(SERVICE_REQUESTS_MANAGER_REQUESTS_TABLE_GRID),
  selection: makeSelectSelection(SERVICE_REQUESTS_MANAGER_REQUESTS_TABLE_GRID),
});

function mapDispatchToProps(dispatch) {
  return {
    executeAcceptAction: () => dispatch(executeAcceptAction(SERVICE_REQUESTS_MANAGER_REQUESTS_FORM_DIALOG)),
    executeRejectAction: () => dispatch(executeRejectAction(SERVICE_REQUESTS_MANAGER_REQUESTS_FORM_DIALOG)),
    executeSendToAgreementByTenantAction: () => dispatch(executeSendToAgreementByTenantAction(SERVICE_REQUESTS_MANAGER_REQUESTS_FORM_DIALOG)),
    executeCloseAction: () => dispatch(executeCloseAction(SERVICE_REQUESTS_MANAGER_REQUESTS_FORM_DIALOG)),
    executeSendToPerformer: () => dispatch(executeSendToPerformer(SERVICE_REQUESTS_MANAGER_REQUESTS_FORM_DIALOG)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ServiceRequestsManagerFormDialogContainer14326);
